import { Box, HStack, Text } from '@chakra-ui/react'
import React from 'react'

import { LabelValuePair } from './LabelValuePair'

export const HorizontalLabelValuePair = ({
  emptyPlaceholder,
  label,
  value,
}: React.ComponentProps<typeof LabelValuePair>) => {
  return (
    <HStack alignItems="flex-start">
      <Text as="span" color="neutral.50" fontSize="14px">
        {label}:
      </Text>
      <Box
        as="span"
        fontSize="14px"
        whiteSpace="pre-line"
        wordBreak="break-all"
      >
        {value
          ? value
          : emptyPlaceholder !== undefined
          ? emptyPlaceholder
          : '-'}
      </Box>
    </HStack>
  )
}
